// File generated from our OpenAPI spec
export const ApiVersion = '2025-09-30.clover';
export const ApiMajorVersion = 'clover';
